import { Injectable } from '@angular/core';
import { Headers, Http, Response, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../../../environments/environment';
import { JwtService } from './jwt.service';
import { Router } from '@angular/router';

@Injectable()
export class ApiService {
  constructor(
    private http: Http,
    private jwtService: JwtService,
    private router: Router
  ) { }

  private setHeaders(): Headers {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    if (this.jwtService.getToken()) {
      headersConfig['Authorization'] = `${this.jwtService.getToken()}`;
      var localId = sessionStorage.getItem('localeId');

      var languageId = 1053;
      if (localId == 'en') {
        languageId = 1033;
      }

      headersConfig['Accept-Language'] = `${languageId}`;

    }
    return new Headers(headersConfig);
  }

  private formatErrors(error: any) {

    // if (error.status == 401 || error.status == 403) {

    //   // this.jwtService.destroyToken();
    //   return this.router.navigate(['/authentication/login']);
    // }

    return Observable.throw(error);
  }

  get(path: string, params: URLSearchParams = new URLSearchParams()): Observable<any> {
    return this.http.get(
      `${environment.api_url}${path}`,
      { headers: this.setHeaders(), search: params }
    )
      .catch(this.formatErrors)
      .map((res: Response) => res);
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    )
      .catch(this.formatErrors)
      .map((res: Response) => res);
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      { headers: this.setHeaders() }
    )
      .catch(this.formatErrors)
      .map((res: Response) => res);
  }

  delete(path): Observable<any> {
    return this.http.delete(
      `${environment.api_url}${path}`,
      { headers: this.setHeaders() })
      .catch(this.formatErrors)
      .map((res: Response) => res);
  }

  fileUpload(path: string, formData): Observable<any> {
    const headersConfig = {};
    if (this.jwtService.getToken()) {
      headersConfig['Authorization'] = `${this.jwtService.getToken()}`;

      var localId = sessionStorage.getItem('localeId');

      var languageId = 1053;
      if (localId == 'en') {
        languageId = 1033;
      }

      headersConfig['Accept-Language'] = `${languageId}`;
    }
    let headers = new Headers(headersConfig);
    headers.delete('Content-Type');
    let options = new RequestOptions({ headers: headers });
    return this.http.post(`${environment.api_url}${path}`, formData, options)
      .catch(this.formatErrors)
      .map(res => res)
  }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/authentication/guards/api.service.ts